<div class="side-content">
  <!-- Pixel Tracking Page Content -->
  <div *ngIf="isPixelTrackingPage()" class="side-content-cards">
    <div class="getting-started-card">
      <h2 class="text-2xl md:!text-[20px]">Getting Started</h2>
      <p class="md:!text-[15px]">Learn all about tracking, pixels, and more!</p>

      <p class="video-description md:!text-[15px]">
        Watch our quick video which will introduce you to tracking pixels and
        how they are crucial to a successful ad.
      </p>

      <div class="video-container w-full xl:w-[70%] 2xl:w-full">
        <iframe 
          class="w-full h-55 sm:h-75 md:h-85 xl:h-85 2xl:h-55 rounded-2xl"
          src="https://www.youtube.com/embed/79iO4b5ekdk" 
          title="Getting Started with Tracking Pixels"
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          allowfullscreen>
        </iframe>
      </div>
    </div>

    <div class="tech-wizard-card">
      <h2 class="text-2xl md:!text-[20px]">Not a tech wizard?<br />No problem.</h2>
      <p class="md:!text-[15px]">
        If installing your pixel feels like learning a new language, our
        preferred partner can do it for you—yes, an actual human. For a small
        fee, they'll get you set up right, so your ads perform their absolute
        best.
      </p>
      <a href="https://authoritie.io/support/" target="_blank" rel="noopener noreferrer" class="help-button inline-flex items-center justify-center">
        <span>Request Pixel Help</span>
        <img
          src="assets/icons/question-circle.svg"
          alt="Help"
          class="help-icon"
        />
      </a>
    </div>
  </div>

  <!-- Account Page Content -->
  <div *ngIf="isAccountPage() || isDashboardPage()" class="insiders-card">
    <h2 class="text-xl !md:text-[20px] !font-semibold mb-4">Authoritie Insiders</h2>
    <p class="font-bold text-lg !mb-0 text-[16px] md:text-[14px] ">
      <i>Pull up a seat. We saved one for you.</i> 
    </p>
    <p class="mt-0 text-[16px] md:text-[14px] ">
      A weekly newsletter for smart ad tips, growth strategies, and behind-the-scenes secrets we
      usually save for our high-paying clients.
    </p>
    <a href="https://authoritie.io/newsletter/" target="_blank" rel="noopener noreferrer" class="bg-[#2D2A3A] hover:bg-black/80 text-white font-medium py-3 px-6 rounded-full flex items-center justify-center w-auto inline-flex">
      <span>Get On The List</span>
      <img src="assets/icons/arrow-right.svg" alt="Arrow" class="ml-2" />
    </a>
  </div>

  <!-- Recent Ads Page Content -->
  <div *ngIf="isRecentAdsPage() || isAdBalancePage()" class="{{isRecentAdsPage() ? 'mr-7 md:mr-15 lg:mr-0' : ''}}">
    <!-- <div class="search-container bg-[#ECEAF3] rounded-2xl p-6 mb-6">
      <div class="relative">
        <input 
          type="text" 
          placeholder="Search Ads..." 
          class="w-full bg-transparent text-[#A0A0A0] font-light placeholder:text-[#A0A0A0] focus:outline-none"
        >
        <img 
          src="assets/icons/search-input.svg" 
          alt="Search" 
          class="absolute right-0 top-1/2 -translate-y-1/2 w-6 h-6"
        >
      </div>
    </div> -->

    <!-- Container for cards with conditional 2-column layout -->
    <div class="{{isAdBalancePage() && shouldShowCurrentPlanCard() ? 'grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-1 gap-6' : 'flex flex-col gap-6'}}">
      <!-- Authoritie Insiders Card -->
      <div class="p-8 rounded-2xl text-white insiders-card order-2 2xl:order-1">
        <h3 class="text-2xl !md:text-[20px] !font-semibold mb-4">Authoritie Insiders</h3>
        <p class="font-bold text-lg !mb-0 text-[16px] md:text-[14px] ">
          <i>Pull up a seat. We saved one for you.</i> 
        </p>
        <p class="mb-6 text-[16px] md:text-[14px]">
          A weekly newsletter for smart ad tips, growth strategies, and
          behind-the-scenes secrets we usually save for our high-paying clients.
        </p>
        <a
          href="https://authoritie.io/newsletter/"
          target="_blank"
          rel="noopener noreferrer"
          class="bg-[#2D2A3A] hover:bg-black/80 text-white font-medium py-3 px-6 rounded-full flex items-center justify-center w-auto inline-flex"
        >
          <span>Get On The List</span>
          <img src="assets/icons/arrow-right.svg" alt="arrow" class="ml-2" />
        </a>
      </div>

      <!-- Current Plan Card -->
      <div *ngIf="shouldShowCurrentPlanCard()" class="p-8 rounded-2xl text-white plan-card bg-[#AB54DB] order-1 2xl:order-2">
        <p class="text-lg">Current Plan</p>
        <p class="text-5xl font-semibold my-2">Monthly</p>
        <p class="text-lg">
          Upgrade to Yearly and <span class="font-bold">save 10%</span>
        </p>
        <button
          (click)="openPlanChangeModal()"
          class="bg-[#2D2A3A] hover:bg-black/80 text-white font-semibold py-3 px-5 rounded-full flex items-center justify-between w-auto mt-6 max-w-[196px]"
        >
          <span>Upgrade Plan</span>
          <div class="flex items-center justify-center ml-2">
            <img src="assets/icons/balance/add.png" alt="plus" />
          </div>
        </button>
        <app-plan-change-confirmation
          [(visible)]="showPlanChangeConfirmation"
          [currentPlan]="currentPlan"
          [newPlan]="newPlan"
          [loading]="isChangingPlan"
          (confirmChange)="onPlanChangeConfirmed($event)"
        ></app-plan-change-confirmation>
      </div>
    </div>
  </div>
</div>
